import React, { useState } from 'react';
import { Bug } from 'lucide-react';
import BugReportDialog from './BugReportDialog';

const BugReportButton: React.FC = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleBugReport = () => {
    setIsDialogOpen(true);
  };

  return (
    <>
      <button
        onClick={handleBugReport}
        className="p-2 rounded-lg hover:bg-slate-400/40 dark:hover:bg-neutral-800 transition-colors text-neutral-700 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-white"
        aria-label="Report a bug"
        title="Report a bug"
        data-tour="bug-report-button"
        data-bug-report-trigger="true"
      >
        <Bug size={18} className="sm:w-5 sm:h-5" />
      </button>
      
      <BugReportDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
};

export default BugReportButton;
